import type { AxiosInstance } from 'axios'
import type { AnnouncementType } from 'src/types/announcements'


export class AnnouncementsApi {
  api: AxiosInstance

  urls = {
    currentAnnouncement: () => 'announcements/current/' as const,
  }

  constructor (api: AxiosInstance) {
    this.api = api
  }

  getCurrentAnnouncement = async (): Promise<AnnouncementType> => {
    const response = await this.api.get<AnnouncementType>(this.urls.currentAnnouncement())
    return response.data
  }
}
